import React from "react";
import { TextInput, Input } from '@mantine/core';

const InputComponent = ({
    stateId = '',
    stateClassName = '',
    stateSize = 'sm',
    stateWithAsterisk = false,
    stateLabel = '',
    stateLabelFullWidth = false,
    stateDescription = '',
    stateVariant = 'default',
    statePlaceHolder = '',
    stateReadOnly = false,
    stateDisabled = false,
    stateValue = '',
    stateError = '',
    stateIcon = null,
    stateRightSection = null,
    stateSXWrapper = {},
    stateMT = '0',
    stateMB = '0',
    stateStylesInput = {},
    fnOnChange = () => null,
    fnOnKeyUp = () => null,
    fnOnClick = () => null,
}) => {
    return (
        <Input.Wrapper
            id={stateId}
            size={stateSize}
            withAsterisk={stateWithAsterisk}
            label={stateLabel}
            description={stateDescription}
            sx={stateSXWrapper}
            mt={stateMT}
            mb={stateMB}

            styles={(tema) => ({
                label: stateLabelFullWidth ? {
                    width: '100%',
                    marginBottom: '.25rem'
                } : {
                    marginBottom: '.25rem'
                },
            })}
        >
            <TextInput
                id={stateId}
                classNames={{
                    input: stateClassName
                }}
                variant={stateVariant}
                placeholder={statePlaceHolder}
                readOnly={stateReadOnly}
                disabled={stateDisabled}
                icon={stateIcon}
                rightSection={stateRightSection}
                styles={() => ({
                    input: stateStylesInput,
                })}
                value={stateValue}
                error={stateError}
                onChange={(e) => fnOnChange(e)}
                onKeyUp={(e) => fnOnKeyUp(e)}
                onClick={(e) => fnOnClick(e)}
            />
        </Input.Wrapper>
    )
}

export default React.memo(InputComponent);